import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import BuilderIcon from '@/components/icons/BuilderIcon'
import MediaIcon from '@/components/icons/MediaIcon'
import EditIcon from '@/components/icons/EditIcon'
import SortIcon from '@/components/icons/SortIcon'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 480,
      sm: 768,
      md: 960,
      lg: 1920,
      xl: 2560
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#075782',
        secondary: '#0CB5B8',
        accent: '#45A3D6',
        error: '#E23636',
        info: '#303030',
        success: '#0CB851',
        warning: '#FF7D34'
      },
      dark: {
        primary: '#075782',
        secondary: '#0CB5B8',
        accent: '#45A3D6',
        error: '#E23636',
        info: '#303030',
        success: '#0CB851',
        warning: '#FF7D34'
      }
    }
  },
  icons: {
    values: {
      builder: {
        component: BuilderIcon
      },
      media: {
        component: MediaIcon
      },
      edit: {
        component: EditIcon
      },
      sort: {
        component: SortIcon
      }
    }
  }
})
